import React from "react"
import HomeConsultationWrapper from "./shared/homeConsultationWrapper/HomeConsultationWrapper"
import HomeConsultationDescription from "./shared/homeConsultationDescription/HomeConsultationDescription"
import HomeConsultationForm from "./shared/homeConsultationForm/HomeConsultationForm"

const HomeConsultation = ({
  handleEmailChange,
  handleNameChange,
  email,
  name,
  handleSubmit,
  path,
  errors,
  loading
}) => {
  return (
    <HomeConsultationWrapper>
      <HomeConsultationDescription />
      {loading === true ? <div className="loader"/> :
        <HomeConsultationForm
        errors={errors}
        path={path}
        handleSubmit={handleSubmit}
        handleNameChange={handleNameChange}
        handleEmailChange={handleEmailChange}
        email={email}
        name={name}
      />
      }
    </HomeConsultationWrapper>
  )
}

export default HomeConsultation
